export const GIFT_CARDS = {
  INDEX: 'gift_cards',
}
